import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
import store from "./store/store";
import "./assets/style/main.scss";
import './plugins/element.js'
import '@/common/services/interceptor'
import moment from "moment";

Vue.filter('formatData', function formatDate(date) {
    if (!date) {
        date = new Date()
    }
    return moment(date).format('MMM DD, YYYY')

});


Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
    render: h => h(App),
    router: router,
    store: store
}).$mount('#app');
